import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/cardBlockers/'
export const ADD = NAMESPACE + 'ADD'
export const SET = NAMESPACE + 'SET'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const REMOVE_ALL_FOR_CARD_ID = NAMESPACE + 'REMOVE_ALL_FOR_CARD_ID'
export const SET_REASON = NAMESPACE + 'SET_REASON'
export const SET_USER = NAMESPACE + 'SET_USER'

const initialState = {
  ids: [],
  byId: {},
}

export default function reducer (state: any = initialState, action: any = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        ids: addUniqueValueToArray({
          array: state.ids,
          value: action.payload.cardBlocker.id,
          index: action.payload.index
        }),
        byId: {
          ...state.byId,
          [action.payload.cardBlocker.id]: {
            ...state.byId[action.payload.cardBlocker.id],
            ...action.payload.cardBlocker,
          }
        },
      }
    case SET:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            ...action.payload.cardBlocker,
          }
        },
      } : state
    case ADD_ARRAY: {
      const newState = {
        ...state,
        ids: [ ...state.ids ],
        byId: { ...state.byId },
      }

      action.payload.cardBlockers.forEach(cardBlocker => {
        newState.ids = addUniqueValueToArray({
          array: newState.ids,
          value: cardBlocker.id,
          index: undefined,
        })
        newState.byId[cardBlocker.id] = {
          ...newState.byId[cardBlocker.id],
          ...cardBlocker,
        }
      })

      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        ids: state.ids.filter(id => id !== action.payload.cardBlockerId),
        byId: { ...state.byId }
      }

      delete newState.byId[action.payload.cardBlockerId]

      return newState
    }
    case REMOVE_ALL_FOR_CARD_ID: {
      let changed = false

      const newState = {
        ...state,
        byId: { ...state.byId }
      }

      newState.ids = state.ids.filter(id => {
        const filter = state.byId[id].cardId !== action.payload.cardId

        if (!filter) {
          changed = true

          delete newState.byId[action.payload.cardBlockerId]
        }

        return filter
      })

      return changed ? newState : state
    }
    case SET_REASON:
      return state.byId[action.payload.cardBlockerId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardBlockerId]: {
            ...state.byId[action.payload.cardBlockerId],
            reason: action.payload.reason,
          }
        }
      } : state
    case SET_USER:
      return state.byId[action.payload.cardBlockerId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardBlockerId]: {
            ...state.byId[action.payload.cardBlockerId],
            userId: action.payload.userId,
          }
        }
      } : state
    default: return state
  }
}

export function add ({ cardBlocker }) {
  return {
    type: ADD,
    payload: {
      cardBlocker,
    }
  }
}

export function set ({ id, ...cardBlocker }) {
  return {
    type: SET,
    payload: {
      id,
      cardBlocker
    }
  }
}

export function addArray ({ cardBlockers }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardBlockers,
    }
  }
}

export function remove ({ cardBlockerId }) {
  return {
    type: REMOVE,
    payload: {
      cardBlockerId,
    }
  }
}

export function removeAllForCardId ({ cardId }) {
  return {
    type: REMOVE_ALL_FOR_CARD_ID,
    payload: {
      cardId,
    }
  }
}

export function setReason ({ cardBlockerId, reason }) {
  return {
    type: SET_REASON,
    payload: {
      cardBlockerId,
      reason,
    }
  }
}

export function setUser ({ cardBlockerId, userId }) {
  return {
    type: SET_USER,
    payload: {
      cardBlockerId,
      userId,
    }
  }
}